import React from 'react';
import { connect } from 'react-redux';
import { Loading } from '../UI/Loading';
import { CrosswordListItem } from './CrosswordListItem';
import { updateCrosswordStatus, deleteCrossword, } from '../../redux/actions/crosswords';
const CrosswordListComponent = ({ loading, crosswords, layout, deleteCrossword, updateCrosswordStatus, error, errorDetail, }) => {
    const handleDeleteCrossword = (crosswordId) => {
        deleteCrossword(crosswordId);
    };
    const handleStatusUpdate = (crosswordId, status) => {
        updateCrosswordStatus({ crosswordId, status });
    };
    return error ? (React.createElement("div", null, errorDetail)) : loading ? (React.createElement(Loading, null)) : crosswords.length < 1 ? (React.createElement("div", { style: {
            width: '70%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
        } },
        React.createElement("p", { style: { textAlign: 'center', color: 'grey' } }, "Wow, such emptiness. Why don't you create a new crossword. :)"))) : (React.createElement("div", { className: layout === 'Grid' ? 'activity-grid' : 'activity-list' }, crosswords.map((crossword) => (React.createElement(CrosswordListItem, { key: crossword.crosswordId, crossword: crossword, onDelete: handleDeleteCrossword, onStatusUpdate: handleStatusUpdate })))));
};
const mapStateToProps = (state) => ({
    loading: state.crosswordState.loading,
    error: state.crosswordState.error,
    errorDetail: state.crosswordState.errorDetail,
});
const mapDispatchToProps = {
    updateCrosswordStatus,
    deleteCrossword,
};
export const CrosswordList = connect(mapStateToProps, mapDispatchToProps)(CrosswordListComponent);
